import React, { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const AE_COLOR = "hsl(38, 92%, 50%)";
const AM_COLOR = "hsl(142, 71%, 45%)";

export default function AccountTeamChart({ races }) {
  const data = useMemo(() => {
    const counts = {};
    races.forEach((r) => {
      const ae = r._ad?.account_executive;
      const am = r._ad?.account_manager;
      if (ae) {
        if (!counts[ae]) counts[ae] = { name: ae, ae: 0, am: 0 };
        counts[ae].ae++;
      }
      if (am) {
        if (!counts[am]) counts[am] = { name: am, ae: 0, am: 0 };
        counts[am].am++;
      }
    });
    return Object.values(counts)
      .map((d) => ({ ...d, total: d.ae + d.am }))
      .sort((a, b) => b.total - a.total);
  }, [races]);

  return (
    <div className="bg-card border border-border rounded-lg p-5 space-y-3 lg:col-span-2">
      <p className="text-sm font-semibold">Races by Account Executive / Account Manager</p>
      {data.length === 0 ? (
        <p className="text-xs text-muted-foreground py-10 text-center">No data</p>
      ) : (
        <ResponsiveContainer width="100%" height={Math.max(160, data.length * 36)}>
          <BarChart data={data} layout="vertical" margin={{ left: 10, right: 20, top: 0, bottom: 0 }}>
            <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="hsl(220,16%,90%)" />
            <XAxis type="number" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} allowDecimals={false} />
            <YAxis type="category" dataKey="name" tick={{ fontSize: 12 }} tickLine={false} axisLine={false} width={55} />
            <Tooltip
              cursor={{ fill: "hsl(220,16%,96%)" }}
              contentStyle={{ fontSize: 12, border: "1px solid hsl(220,16%,88%)", borderRadius: 6 }}
            />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar dataKey="ae" name="Account Executive" stackId="a" fill={AE_COLOR} radius={[0, 0, 0, 0]} />
            <Bar dataKey="am" name="Account Manager" stackId="a" fill={AM_COLOR} radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}